module.exports = __webpack_public_path__ + "static/3-8dade6f99403a167948a23012ede51dc.png";